module.exports = __webpack_public_path__ + "static/img/success-ico.4b1eadb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img-4/success-ico.png
// module id = 97l5
// module chunks = 1